import React from "react";
import { Route, Routes } from "react-router-dom";
import Companies from "../Companies";
import CompaniesHome from "../CompaniesHome/CompaniesHome";
import ViewCompany from "../ViewCompany/ViewCompany";
import CreateCompany from "../CreateCompany";


export default function CompaniesRoutes(){

    return(
        <Routes>
          <Route element={<Companies/>}>
             <Route index element={<CompaniesHome/>}/>
              <Route path=':CompanyID'>
                <Route index element={<ViewCompany/>} />
              </Route>
              <Route path='create'>
                <Route index element={<CreateCompany/>} />
              </Route>
          </Route>
        </Routes>
        
    )
}